import { useTranslation as useI18nTranslation } from 'react-i18next';
import { useLanguage } from './LanguageContext';

// A custom hook that combines `useTranslation` and `useLanguage`
const useCustomTranslation = () => {
  const { t: trans, i18n } = useI18nTranslation();
  const { changeLanguage } = useLanguage();

  return {
    trans,            // Translation function from i18next
    i18n,          // i18n instance, useful for changing languages programmatically
    changeLanguage, // Language change function from your custom context
  };
};

export default useCustomTranslation;
